const EventsDetails = [
  {
    title: "National Space Day 2024",
    hosting: "By Space Exploration Society",
    club: "SES",
    description: (
      <>
        <b>Exploring New Horizons: Celebrating India's Space Legacy</b> <br />
        To commemorate the success of Chandrayaan-3 mission on its first
        anniversary, Space Exploration Society and Department of Physics at IIT
        Bhilai are delighted to invite you all to celebrate the National Space
        Day with us. Get ready to spend the day with exciting sessions of fun
        and knowledge outreach throughout the day to celebrate India’s greatest
        achievements. Looking forward for your participation to make this event
        a resounding success.
        <br />
        <br />
        <b>Major Events:</b>
        <ul>
          <li>1. VR Space Simulation</li>
          <li>2. Working model display of RC Plane and Drones</li>
          <li>3. Documentary Screening</li>
          <li>4. Space Themed Sketching</li>
        </ul>
      </>
    ),
    date: "24",
    month: "Aug",
    year: "2024",
    time: "12:00-2:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/Space_Day.jpg",
    isSingleEvent: true,
  },
  {
    title: "CRYPTOPULSE Summer Bootcamp",
    hosting: "By Blockchain at IIT Bhilai (BIB)",
    club: "BIB",
    description:
      "The CryptoPulse Summer Bootcamp is an intensive program designed to immerse participants in the world of blockchain technology and cryptocurrencies. Over the course of the bootcamp, attendees will learn the fundamentals of blockchain, smart contracts, decentralized finance (DeFi), and the latest trends in the crypto space. The bootcamp includes hands-on sessions, expert talks, and collaborative projects to help participants build practical skills and knowledge.",
    date: "29",
    month: "May",
    year: "2024",
    time: "12:00-2:00 PM IST",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: false,
  },
  {
    title: "Summer Of Electronics",
    hosting: "By Electromos",
    club: "Electromos",
    description:
      "The Electromos club decided to conduct summer online workshop for the Student of our institute . This year the first Summer Of Electronics workshops were conducted. This year 3 major workshops were conducted, this included workshops on MATLAB & Simulink, PCB designing and LTspice circuit simulation. Certificate of completion were also awarded to sincere students who attended all sessions and solved the problem statements. This initiative will continue every year from now.",
    date: "08",
    month: "May",
    year: "2024",
    time: "BootCamp",
    location: "IIT Bhilai",
    image: "/events/PCB_S2.png",
    isSingleEvent: false,
  },
  {
    title: "Gradient Overflow BootCamp",
    hosting: "By DSAI",
    club: "DSAI",
    description: (
      <>
        This event hosted by DSAI club is a 2 month long bootcamp for beginners
        in the field of Data Science and AI. The bootcamp will cover the basics
        of Python, Machine Learning, Deep Learning starting from mathematical
        foundations to practical implementations. Comprising of 12 sessions, the
        bootcamp will dive into the world of data science and AI. Access the
        recordings of the sessions{" "} 
        <a className="text-blue-700" href="https://youtube.com/playlist?list=PLRsLWy71mrwjd7sn7js0OC15mnGs8XWJB&feature=shared">
          <u>here</u>
        </a>
        .
      </>
    ),
    date: "13",
    month: "May",
    year: "2024",
    time: "BootCamp",
    location: "IIT Bhilai",
    image: "/events/Gradient_Overflow.jpg",
    isSingleEvent: false,
  },
  {
    title: "CodeForge",
    hosting: "By Openlake",
    club: "Openlake",
    description:
      "CodeForge is a month-long summer bootcamp designed for beginners to kickstart their journey into open source. It introduces essential topics like Git, GitHub, web development, and more. The bootcamp includes hands-on sessions and projects, providing practical experience to help you confidently contribute to open source projects.",
    date: "13",
    month: "May",
    year: "2024",
    time: "BootCamp",
    location: "IIT Bhilai",
    image: "/events/codeforge.png",
    isSingleEvent: false,
  },
  {
    title: "Summer of robotics",
    hosting: "By Epsilon",
    club: "Epsilon",
    description:
      "This is an interactive bootcamp that invites young enthusiasts to delve into the fascinating world of technology and innovation. From learning about basic Sensors, Arduino to Advanced concepts like ROS(Robot Operating System), OpenCV , Control System and Drones , they embark on an unforgettable journey of learning and discovery in Robotics!",
    date: "11",
    month: "May",
    year: "2024",
    time: "BootCamp",
    location: "IIT Bhilai",
    image: "/events/SOR_SESSION.png",
    isSingleEvent: false,
  },
  {
    title: "Summer Drive",
    hosting: "By The Cyber Security Club",
    club: "Spectre",
    description: (
      <>
        The Cyber Security started teaching a brief idea about bash and shell
        scripting which will be the key aspects in further learning. Then we
        proceeded with the Linux file system and hierarchy. Gave a sample CTF
        over tryhackeme.com and overthewire.org.
      </>
    ),
    date: "11",
    month: "May",
    year: "2024",
    time: "3:00-4:00 PM ",
    location: "Online",
    isSingleEvent: false,
  },
  {
    title: "Introductory Session For Cyber-Security",
    hosting: "By The Cyber Security Club",
    club: "Spectre",
    description: (
      <>
        <b>Exploring various fields and methods of Cyber Security</b>
        <br />
        To give a view of what CyberSecurity is gonna be and what people can
        expect to dwelling into the world of cybersecurity. A brief of idea
        about various topics that are going to be taught in the club.
        <br />
        <br />
        <b>Topics Of The session:</b>
        <ul>
          <li>Cyber Security</li>
          <li>Cryptography</li>
          <li>Capture the Flags</li>
        </ul>
      </>
    ),
    date: "13",
    month: "Apr",
    year: "2024",
    time: "09.00-10.30 PM IST",
    location: "IIT Bhilai",
    isSingleEvent: true,
  },
  {
    title: "SPACE and FUN",
    hosting: "Space Exploration Society and Department of Physics",
    club: "SES",
    description: (
      <>
        The Space Exploration Society (SES), with the Department of Physics,
        shared their extensive knowledge with the bright minds of Krishna Public
        School during an event celebrating the upcoming "National Space Day."
        The session was an inspiring journey into the universe's wonders, aiming
        to ignite the students' passion for space exploration. The session
        concluded with the inspiring words of our honourable Director, who
        emphasised the importance of curiosity, innovation, and dedication in
        the field of space exploration.
      </>
    ),
    date: "17",
    month: "Aug",
    year: "2024",
    time: "10:00-2:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/ses2.jpg",
    isSingleEvent: true,
  },
  {
    title: "Igniting the curiosity about space among young minds",
    hosting: "Space Exploration Society and Department of Physics",
    club: "SES",
    description: (
      <>
        The team of SES, along with the Department of Physics at IIT Bhilai,
        enlightened the minds of the young students at Jawahar Navodaya
        Vidyalaya under the leadership of Director Prof. Rajiv Prakash, leading
        up to National Space Day.
      </>
    ),
    date: "04",
    month: "Aug",
    year: "2024",
    time: "11:00-2:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/ses3.jpg",
    isSingleEvent: true,
  },
  {
    title: "Introductory Session of DSAI Club-2024",
    hosting: "By DSAI Club",
    club: "DSAI",
    description: (
      <>
        This was the first session conducted for the students of the first year
        by the DSAI Club and it was conducted in the offline mode. The session
        was an introductory session of the club which focussed on delivering
        information about the club, the past achievements and events conducted,
        the future plans of the present tenure, etc. In the session, the
        coordinators and core members of the club first took a small session
        about the basics of AI/ML and then showcased their projects for creating
        curiosity among the students.
      </>
    ),
    date: "19",
    month: "Aug",
    year: "2024",
    time: "6:00 - 8:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/Event15.jpg",
    isSingleEvent: true,
  },
  {
    title: "MATLAB Sessions",
    hosting: "Summer of Electronics 1.0",
    club: "Electromos",
    description: (
      <>
        Summer of Electronics 1.0 was an engaging workshop organized by the
        Electromos Club with the goal of enhancing participants' understanding
        of various aspects of electronics. This workshop comprised a series of
        detailed sessions focused on three essential tools: MATLAB. Conducted
        via Google Meet, the workshop offered a flexible and interactive virtual
        learning environment. Participants had the opportunity to delve into
        MATLAB for advanced data analysis and simulation.
      </>
    ),
    date: "15",
    month: "May",
    year: "2024",
    time: "5:00-6:00 PM IST",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: true,
  },

  {
    title: "EAGLE CAD Sessions",
    hosting: "Summer of Electronics 1.0",
    club: "Electromos",
    description: (
      <>
        Summer of Electronics 1.0 was an engaging workshop organized by the
        Electromos Club with the goal of enhancing participants' understanding
        of various aspects of electronics. This workshop comprised a series of
        detailed sessions focused on three essential tools: EAGLE CAD. Conducted
        via Google Meet, the workshop offered a flexible and interactive virtual
        learning environment. Participants had the opportunity to delve into
        Eagle CAD for designing and laying out printed circuit boards (PCBs)
      </>
    ),
    date: "16",
    month: "June",
    year: "2024",
    time: "5:00-6:00 PM IST",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: true,
  },
  {
    title: "LTspice Sessions",
    hosting: "Summer of Electronics 1.0",
    club: "Electromos",
    description: (
      <>
        Summer of Electronics 1.0 was an engaging workshop organized by the
        Electromos Club with the goal of enhancing participants' understanding
        of various aspects of electronics. This workshop comprised a series of
        detailed sessions focused on three essential tools: LTspice. Conducted
        via Google Meet, the workshop offered a flexible and interactive virtual
        learning environment. Participants had the opportunity to master LTspice
        for comprehensive circuit simulation. Each session was designed to
        provide both theoretical insights and practical hands-on experience,
        fostering a deeper grasp of electronic design and analysis.{" "}
      </>
    ),
    date: "14",
    month: "July",
    year: "2024",
    time: "5:00-6:00 PM IST",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: true,
  },
  {
    title: "Introductory Session of Electromos Club-2024",
    hosting: "By Electromos Club",
    club: "Electromos",
    description: (
      <>
        On August 17th, Electromos organized an introductory session for the
        students of IIT Bhilai to provide them with a comprehensive
        understanding of the club's activities and objectives. During the
        session, we presented an overview of the club's mission, the diverse
        range of projects we undertake, and the specific roles and contributions
        we are seeking from new members. We aimed to clearly communicate what
        Electromos is all about, including the opportunities for hands-on
        involvement and the benefits of participating in our electronics-focused
        initiatives. This session was designed to inform and engage students,
        encouraging them to actively contribute to and benefit from being part
        of our vibrant electronics community.
      </>
    ),
    date: "17",
    month: "Aug",
    year: "2024",
    time: "11:00 AM - 1:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/intro_electromos.jpg",
    isSingleEvent: true,
  },
  {
    title: "Hands on Session",
    hosting: "The Epsilon Club",
    club: "Epsilon",
    description: (
      <>
        The Epsilon Club proudly hosted an engaging and immersive hands-on
        workshop dedicated to the fascinating world of servo motors. This
        comprehensive session was meticulously designed to introduce
        participants to the fundamental principles and practical applications of
        servo motors. Attendees delved into the inner workings of these
        precision components, exploring everything from their basic operational
        mechanics to advanced control techniques. The workshop featured
        interactive demonstrations, including live wiring exercises and
        real-time programming challenges, allowing participants to gain
        invaluable experience and hands-on skills. Whether you were a novice or
        looking to refine your expertise, the session provided a deep dive into
        servo motor technology, complete with practical projects and
        troubleshooting tips to ensure a well-rounded understanding of this
        critical technology.
      </>
    ),
    date: "20",
    month: "Nov",
    year: "2023",
    time: "7:00-8:00 PM IST",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: true,
  },
  {
    title: "Lockout Tournament",
    hosting: "Ingenuity",
    club: "Ingenuity",
    description: (
      <>
        In the Lockout Tournament, coders faced off in a high-stakes 1v1 battle
        where only the sharpest minds prevailed. Each match was a race against
        the clock, with participants striving to solve the most problems before
        their opponent can. Strategy and speed were key, as every correct
        solution locks the problem from the other competitor, turning the
        contest into a thrilling head-to-head clash. With each round, the
        competition intensified, pushing coders to outthink and outpace their
        rivals in a true test of skill and determination.
      </>
    ),
    date: "15",
    month: "March",
    year: "2024",
    time: "03:00-6:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/lockout.jpg",
    isSingleEvent: true,
  },
  {
    title: "Introductory Session",
    hosting: "Openlake",
    club: "Openlake",
    description: (
      <>
        Openlake has recently its introductory session for the tenure 2024-25.
        The session underscored the transformative potential of open-source
        technology in driving innovation and solving complex problems. The
        people even having zero knowledge about open source software were given
        useful insights with intriguing hands on session!{" "}
      </>
    ),
    date: "17",
    month: "Aug",
    year: "2024",
    time: "4:00-5:00PM",
    location: "IIT Bhilai",
    image: "",
    isSingleEvent: true,
  },
  {
    title: "WebWave2.0",
    hosting: "Openlake",
    club: "Openlake",
    description: (
      <>
        Openlake has successfully conducted it's first hackathon of the
        tenure:WebWave 2.0.The problem statements were provided to students
        participating in teams which consists of issues in website. The
        hackathon witnessed some amazing solutions coming up from the
        participants and unlocked the creative world of solutions among them.
      </>
    ),
    date: "1",
    month: "Sep",
    year: "2024",
    time: "1:30-7:00PM",
    location: "IIT Bhilai",
    Image:
      " https://drive.google.com/drive/folders/1jSfeCXlM1uilEYDCAdcRYFE2LDPgF2_m ",
    isSingleEvent: true,
  },
  {
    title: "Introductory Session",
    hosting: "Ingenuity",
    club: "Ingenuity",
    description: (
      <>
        The introductory session by the Competitive Coding Club was designed to
        familiarize participants with competitive programming and introduce them
        to the field of algorithmic efficiency and accuracy-based challenges.
        Attendees explored the nuances of competitive coding based off of
        effective problem-solving. The session concluded with a small contest,
        providing participants with a hands-on opportunity to apply what they
        had learned. Core members were present to offer guidance and address any
        questions, ensuring a supportive environment for all participants.
      </>
    ),
    date: "24",
    month: "Aug",
    year: "2024",
    time: "05:00-8:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/intro_ingenuity.jpg",
    isSingleEvent: true,
  },
  {
    title: "Introductory Session",
    hosting: "The Epsilon Club",
    club: "Epsilon",
    description: (
      <>
        The Epsilon Club hosted an engaging introductory session specifically
        designed for freshers, aimed at sparking their interest in robotics.
        This event showcased the vibrant activities and projects undertaken by
        the club, offering a comprehensive glimpse into the exciting world of
        robotics. Participants had the opportunity to explore the diverse range
        of projects developed by the club members, gaining insight into our
        innovative work and hands-on initiatives. The session was crafted to
        inspire and inform new students, highlighting the club's dynamic
        environment and the various ways they could become involved in our
        robotics community.
      </>
    ),
    date: "6",
    month: "Aug",
    year: "2024",
    time: "2:00-4:00 PM IST",
    location: "IIT Bhilai",
    image: "/events/intro_epsilon.jpg",
    isSingleEvent: true,
  },
];

export default EventsDetails;
